module.exports = __webpack_public_path__ + "static/bushido-1-223e494fca3d61165fccf8810d857de4.png";